/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1TutoraiDashboardReport200,
  GetApiV1TutoraiDashboardReport400,
  GetApiV1TutoraiDashboardReport401,
  GetApiV1TutoraiDashboardReport500,
  GetApiV1TutoraiDashboardReportQueryParams,
  GetApiV1TutoraiDashboardReportQueryResponse,
} from "../../types/tutorAIDashboardController/GetApiV1TutoraiDashboardReport.ts";
import { tutorAIDashboardReportViewModelSchema } from "../tutorAIDashboardReportViewModelSchema.ts";

export const getApiV1TutoraiDashboardReportQueryParamsSchema = z
  .object({
    start: z.optional(z.string().date()),
    end: z.optional(z.string().date()),
    classStudentId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1TutoraiDashboardReportQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1TutoraiDashboardReport200Schema = z.lazy(
  () => tutorAIDashboardReportViewModelSchema,
) as unknown as ToZod<GetApiV1TutoraiDashboardReport200>;

/**
 * @description Período inválido.
 */
export const getApiV1TutoraiDashboardReport400Schema =
  z.any() as unknown as ToZod<GetApiV1TutoraiDashboardReport400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1TutoraiDashboardReport401Schema =
  z.any() as unknown as ToZod<GetApiV1TutoraiDashboardReport401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1TutoraiDashboardReport500Schema =
  z.any() as unknown as ToZod<GetApiV1TutoraiDashboardReport500>;

export const getApiV1TutoraiDashboardReportQueryResponseSchema = z.lazy(
  () => getApiV1TutoraiDashboardReport200Schema,
) as unknown as ToZod<GetApiV1TutoraiDashboardReportQueryResponse>;
